// Empty / no-data slot. Tables and list pages fall back to this
// when there are no rows. Action slot lets callers nudge the
// operator toward the obvious next step (e.g. a Create button).

import type { ReactNode } from "react";

interface EmptyStateProps {
  title: string;
  description?: ReactNode;
  action?: ReactNode;
}

export function EmptyState({ title, description, action }: EmptyStateProps) {
  return (
    <div
      style={{
        textAlign: "center",
        padding: "48px 24px",
        border: "1px dashed var(--border)",
        borderRadius: 8,
        color: "var(--text-dim)",
      }}
    >
      <div style={{ fontSize: "1rem", color: "var(--text)", marginBottom: 6 }}>
        {title}
      </div>
      {description && (
        <div style={{ fontSize: "0.85rem", marginBottom: action ? 16 : 0 }}>
          {description}
        </div>
      )}
      {action}
    </div>
  );
}
